import AccountShell
  from "./accountShell";

export default function CopyrightNotice() {
  return (
    <AccountShell
      title="Bản quyền & tài liệu PDF"
      description="Thông tin về tài liệu được chia sẻ"
    >
      <div
        className="
          rounded-2xl
          border
          border-amber-200
          bg-amber-50
          p-5
          md:p-6
          text-[14px]
          leading-7
          text-amber-950
        "
      >
        <strong>Lưu ý: </strong>

        Các tài liệu bản PDF được chúng tôi
        sưu tầm nhằm hỗ trợ học tập và chia sẻ
        kiến thức đến cộng đồng. Chúng tôi
        không giữ bản quyền đối với những sách
        này và luôn khuyến khích bạn đọc mua
        sách gốc để ủng hộ tác giả, nhà xuất
        bản, cũng như tôn trọng quyền sở hữu
        trí tuệ. Nếu bạn là chủ sở hữu bản
        quyền và mong muốn tài liệu được gỡ bỏ,
        xin vui lòng liên hệ với chúng tôi{" "}

        <a
          href="tel:0847799799"
          className="
            text-blue-700
            font-bold
          "
        >
          0847 799 799
        </a>
        . Chúng tôi cam kết sẽ xử lý ngay theo
        yêu cầu.
      </div>
    </AccountShell>
  );
}
